import { render, staticRenderFns } from "./ElMenuItem.vue?vue&type=template&id=54228c62&"
import script from "./ElMenuItem.vue?vue&type=script&lang=ts&"
export * from "./ElMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports